import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const fetchCommandes = async params => {
  const commandes = await axios.get('/admin/commandes/fetch', { params })
    .catch((e) => {
      throw new CustomException(e, 'Error fetching commandes')
    })
  return commandes.data
}

export const renvoyerCommande = async id => {
  const params = {
    valide: 1,
    action: 'EXPORT',
    export: 1,
    id: id
  }
  console.log({ params })
  await axios.post('/openweb/admin/admin_commandeEdite', params)
    .catch((e) => {
      throw new CustomException(e, 'Error lors du renvoi de la commande')
    })
}
